var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGlasses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_glasses",
    xmlns: "http://www.w3.org/2000/svg",
    width: 123.896,
    height: 121.251,
    viewBox: "0 0 123.896 121.251",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1009",
    "data-name": "Tracciato 1009",
    d: "M16.05,100.636,2.64,63.007l9.719-34.426L47.343,4.36,88.765,2.553l32.44,24.013,1.966,37.614-16.03,39.946L62.034,120.39Z",
    transform: "translate(-0.926 -0.895)",
    fill: "#9692e3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1010",
    "data-name": "Tracciato 1010",
    d: "M16.425,98.52l-13-36.466L12.847,28.7,46.959,5.078,87.333,3.316l31.355,23.211,1.907,36.484-15.624,38.931-43.811,15.8ZM88.347,0,45.874,1.853,10.02,26.677,0,62.169,13.825,100.96l47.23,20.29,46.4-16.732L123.9,63.559l-2.025-38.743Z",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_622",
    "data-name": "Raggruppa 622",
    transform: "translate(-10073.868 -2182.384)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1015",
    "data-name": "Tracciato 1015",
    d: "M51.91,57.221a7.984,7.984,0,0,1,4.128.6A16.657,16.657,0,0,1,59.9,60.857c2.8,2.419,6.274,4.519,10.115,4.243.954-.068,2.069-.16,3.195-.336l1.3-12.4-17.44-7.42L49.934,57.807a6.206,6.206,0,0,1,1.976-.586",
    transform: "translate(10059.516 2170.699)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1016",
    "data-name": "Tracciato 1016",
    d: "M72.162,76.485a14.933,14.933,0,0,1-9.072-1.067,20.523,20.523,0,0,1-4.538-2.988c-1.278-1.061-2.445-2.582-4.023-3.2-2.574-1-4.62.126-6.058,2.091l.558,7.739,6.741,6.2-.049.149,2.436.766.037-.153L67.269,84.8l5.024-4.979.359-3.412-.49.076",
    transform: "translate(10060.145 2160.417)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1017",
    "data-name": "Tracciato 1017",
    d: "M54.564,118.048l4.123-16.919-2.467-.775-4.962,15.172-.584,1.3Z",
    transform: "translate(10059.197 2146.882)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1018",
    "data-name": "Tracciato 1018",
    d: "M48.88,132l-6.8-2.139a.213.213,0,0,1-.105-.074l-6.54-.645-.819.548.112.69,18.883,5.94.487-.5-.358-.919Z",
    transform: "translate(10066.1 2134.507)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1019",
    "data-name": "Tracciato 1019",
    d: "M103.494,67.608a7.991,7.991,0,0,1,3.567-2.162,16.666,16.666,0,0,1,4.913-.12c3.7.084,7.715-.507,10.5-3.164.693-.66,1.494-1.44,2.251-2.292l-6.889-10.4L99.664,54.846l2.679,14.472a6.186,6.186,0,0,1,1.151-1.71",
    transform: "translate(10038.141 2168.751)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1020",
    "data-name": "Tracciato 1020",
    d: "M128.391,69.847a14.934,14.934,0,0,1-7.678,4.95,20.525,20.525,0,0,1-5.4.583c-1.661,0-3.529-.436-5.137.095-2.622.866-3.483,3.038-3.342,5.468l5.355,5.615,9.142.489.057.147,2.367-.96-.068-.141,6.222-6.716.706-7.039-1.894-2.859-.33.371",
    transform: "translate(10035.065 2160.153)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1021",
    "data-name": "Tracciato 1021",
    d: "M143.321,116.925l-7.587-15.674-2.4.971,5.828,14.861.376,1.374Z",
    transform: "translate(10023.668 2146.496)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1022",
    "data-name": "Tracciato 1022",
    d: "M144.855,128.872l-6.606,2.677a.211.211,0,0,1-.128.01l-5.456,3.664-.283.944.526.462,18.346-7.436.056-.7-.861-.481Z",
    transform: "translate(10024.079 2134.992)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1023",
    "data-name": "Tracciato 1023",
    d: "M83.467,25.571,88.856,36.96,86.482,24.587Z",
    transform: "translate(10045.103 2179.447)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1024",
    "data-name": "Tracciato 1024",
    d: "M102.061,23.6l-1.7,12.75,6.117-11.014Z",
    transform: "translate(10037.843 2179.87)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_324",
    "data-name": "Rettangolo 324",
    width: 108.76,
    height: 102.675,
    transform: "translate(10080.979 2190.015)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGlasses);
export default __webpack_public_path__ + "static/media/Icon_glasses.78f6b017f8a04d85fd84425fccde19f5.svg";
export { ForwardRef as ReactComponent };